var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 101,
    viewBox: "0 0 98 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8883 110.775L110.985 88.6777",
    stroke: "#EDF8EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0981 90.8874L75.6301 75.4194",
    stroke: "#EDF8EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9524 75.4194H75.6301V57.7418",
    stroke: "#EDF8EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3657 95.3897C63.6868 95.9645 58.9384 95.4715 54.4774 93.9478C50.0163 92.4241 45.9585 89.9093 42.6088 86.5923C30.5659 74.6819 30.2538 55.057 41.9514 42.8069C46.4794 38.0541 52.3892 34.8479 58.8422 33.6432C65.2952 32.4385 71.9636 33.2965 77.9015 36.0954C83.8393 38.8944 88.745 43.4921 91.9224 49.2364C95.0998 54.9806 96.3877 61.5796 95.6032 68.097C95.4223 69.5267 95.5693 70.9788 96.033 72.3432C96.4967 73.7076 97.265 74.9485 98.2797 75.9719L99.937 77.6291C100.523 78.2152 100.852 79.0101 100.852 79.8389C100.852 80.6677 100.523 81.4625 99.937 82.0486L82.2593 99.7262C81.6732 100.312 80.8784 100.642 80.0496 100.642C79.2208 100.642 78.4259 100.312 77.8399 99.7262L76.1826 98.0689C75.169 97.0575 73.9382 96.2905 72.5837 95.8262C71.2292 95.362 69.7866 95.2127 68.3657 95.3897Z",
    stroke: "#EDF8EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5 71) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbSm);
export default __webpack_public_path__ + "static/media/bulbSm.4ad964b15885a211cc637036d9352cb3.svg";
export { ForwardRef as ReactComponent };